import { onUnmounted } from '@vue/composition-api';
export default function useStorageListener(cb: (e: StorageEvent) => void, storageKey?: string) {
    const handleStorageChange = (e: StorageEvent) => {
        if (storageKey) {
            if (e.key === storageKey) {
                cb(e);
            }
        } else {
            cb(e);
        }
    };
    window.addEventListener('storage', handleStorageChange);
    onUnmounted(() => {
        window.removeEventListener('storage', handleStorageChange);
    });
}
